<div class="rnd-dashboard-wrapper">

  <!-- Header -->
  <div class="page-header">
    <div>
      <span class="label-rnd">R&amp;D LAB</span>
      <h1>AI Dashboard</h1>
      <p>Widgets added via the AI Admin Assistant appear here. Use the assistant to add more.</p>
    </div>
    <a class="btn-secondary" routerLink="/rnd/ai-admin-assistant">
      <span class="material-icons">smart_toy</span> Open Assistant
    </a>
  </div>

  <!-- Loading -->
  <div class="loading-state" *ngIf="loading">
    <span class="material-icons spin">autorenew</span>
    <p>Loading widgets&hellip;</p>
  </div>

  <!-- Empty -->
  <div class="empty-state" *ngIf="!loading && widgets.length === 0">
    <span class="material-icons">dashboard_customize</span>
    <h2>No widgets yet</h2>
    <p>Go to the <a routerLink="/rnd/ai-admin-assistant">AI Admin Assistant</a> and say something like:<br>
       <em>"Add a bar chart showing complaints by category"</em></p>
  </div>

  <!-- Widget grid -->
  <div class="widget-grid" *ngIf="!loading && widgets.length > 0">
    <div class="widget-card" *ngFor="let widget of widgets">

      <!-- Card header -->
      <div class="widget-header">
        <span class="widget-title">{{ widget.title }}</span>
        <div class="widget-meta">
          <span class="widget-type-badge">{{ widget.widget_type }}</span>
          <button type="button" class="remove-btn" title="Remove widget" (click)="removeWidget(widget)">
            <span class="material-icons">close</span>
          </button>
        </div>
      </div>

      <!-- Loading state -->
      <div class="widget-loading" *ngIf="widget.loading">
        <span class="material-icons spin">autorenew</span>
      </div>

      <!-- Error state -->
      <div class="widget-error" *ngIf="!widget.loading && widget.error">
        <span class="material-icons">error_outline</span>
        <p>Could not load data for <strong>{{ widget.data_source }}</strong></p>
      </div>

      <!-- KPI widget -->
      <div class="kpi-body" *ngIf="!widget.loading && !widget.error && widget.widget_type === 'KPI'">
        <span class="kpi-value">{{ widget.kpiValue }}</span>
        <span class="kpi-source">{{ widget.data_source }}</span>
      </div>

      <!-- Table widget -->
      <div class="table-body" *ngIf="!widget.loading && !widget.error && widget.widget_type === 'TABLE'">
        <div class="table-row header-row">
          <span>Label</span><span>Value</span>
        </div>
        <div class="table-row" *ngFor="let row of widget.tableRows">
          <span>{{ row.label }}</span><span>{{ row.value }}</span>
        </div>
        <p class="table-empty" *ngIf="!widget.tableRows?.length">No data available.</p>
      </div>

      <!-- Chart widget -->
      <div class="chart-body" *ngIf="!widget.loading && !widget.error && isChart(widget) && widget.chartOptions">
        <highcharts-chart
          [Highcharts]="Highcharts"
          [options]="widget.chartOptions"
          style="width:100%;display:block;">
        </highcharts-chart>
      </div>

      <!-- Footer -->
      <div class="widget-footer">
        <span>Source: {{ widget.data_source }}</span>
        <span>Refreshes every {{ widget.refresh_seconds }}s</span>
      </div>

    </div>
  </div>

</div>
